import type { BoundingBoxWithHeight } from '@viewer3D/types';

export const numbersMatch = (a: number, b: number, precision: number): boolean => {
  const smaller = Math.min(a, b);
  const bigger = Math.max(a, b);
  return bigger - smaller < precision;
};

export const boundsMatch = (
  a: BoundingBoxWithHeight,
  b: BoundingBoxWithHeight,
  precision: number,
): boolean => {
  const keys = Object.keys(a) as (keyof BoundingBoxWithHeight)[];
  return keys.every((key) => numbersMatch(a[key], b[key], precision));
};
